import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { SectionHeadingCenter, Heading } from './styles/SectionHeadingCenter.styled';
import {
  FacilitiesAndServicesSection,
  FacilitiesIcon,
  IconBlock,
  IconDesc,
  IconDescHead,
  FacilitiesImageHeader,
} from './styles/FacilitiesIcon.styled';
import { ButtonDiv, Button } from './styles/Button.styled';

export default function FacilitiesAndServices({ data, id, dir }) {
  return (
    <FacilitiesAndServicesSection backgroundColor={data.backgroundColor} id={id} dir={dir}>
      <Container>
        <SectionHeadingCenter>
          <h2>{data.title}</h2>
          <Heading className="description_sub1 fs_sub" dir={dir}>
            {data.description}
          </Heading>
        </SectionHeadingCenter>
        <FacilitiesIcon>
          {data.items.map(({ content: { title, text, link, icon } }) => (
            <IconBlock to={link ? link.url : '#0'}>
              <FacilitiesImageHeader>
                {icon && <LazyLoadImage src={icon.url} />}
              </FacilitiesImageHeader>
              <IconDesc>
                <IconDescHead dir={dir}>{title}</IconDescHead>
                <p>{text}</p>
              </IconDesc>
            </IconBlock>
          ))}
        </FacilitiesIcon>
        {isEmpty(data.link) || (
          <ButtonDiv className="btn_freezonecta">
            <Button stylevariant="red" href={data.link.url} target="_self" rel="" dir={dir}>
              {data.link.name}
            </Button>
          </ButtonDiv>
        )}
      </Container>
    </FacilitiesAndServicesSection>
  );
}
